import { render, staticRenderFns } from "./DuplicateComplaintsFilter.vue?vue&type=template&id=af809ab0"
import script from "./DuplicateComplaintsFilter.vue?vue&type=script&lang=js"
export * from "./DuplicateComplaintsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports